const placeholders = {
    '[[JobName]]': (job) => job.name ?? '',
    '[[JobDescription]]': (job) => job.jobDescription ?? '',
    '[[SubcontractorCompanyName]]': (job) => job.subcontractorCompanyName ?? '',
    '[[ForemanName]]': (job) => job.foremanName ?? '',
    '[[JobStartTime]]': (_job, jobStartTime) => jobStartTime ?? '',
    '[[WorkOrderNumber]]': (job) => job.workOrderNumber ?? '',
    '[[CustomerName]]': (job) => job.contractCompanyName ?? '',
    '[[Address]]': (job) => job.jobAddress ?? '',
    '[[TypeOfWork]]': (job) => job.jobTypeDescription ?? '',
};

const fallback = (job, jobStartTime) => [
    job.name,
    job.foremanName,
    jobStartTime,
    job.workOrderNumber,
].filter(Boolean).join(' - ');

const placeholderPattern = /\[\[[^\]]+\]\]/g;

const getPlaceholderValue = (value) => String(value ?? '').trim();

const trimLeadingSeparator = (value) => value.replace(/^\s*-\s*/, '');

export const evaluateJobTitle = (template, job, jobStartTime) => {
    if (!template?.trim() || !job) return fallback(job ?? {}, jobStartTime);

    let title = '';
    let lastIndex = 0;

    for (const match of template.matchAll(placeholderPattern)) {
        const [token] = match;
        const getValue = placeholders[token];
        if (!getValue) continue;

        const placeholderIndex = match.index;
        const placeholderEndIndex = placeholderIndex + token.length;
        const value = getPlaceholderValue(getValue(job, jobStartTime));
        const textBeforePlaceholder = template.slice(lastIndex, placeholderIndex);

        if (value) {
            title += title ? textBeforePlaceholder : trimLeadingSeparator(textBeforePlaceholder);
            title += value;
        }

        lastIndex = placeholderEndIndex;
    }

    return `${title}${template.slice(lastIndex)}`.trim();
};
